import { AuthProvider, useAuth } from 'oidc-react';
import React, { useContext, useEffect, useState } from 'react';
import Loading from '../../components/Loading/InitialLoading';
import DialogNotification from '../../components/DialogNotification/DialogNotification';
import UserContext from '../../context/UserContext';
import { getStorageWithTtl, setStorageWithTtl } from '../../utils/functions';
import PROVIDER_CONFIG from './Config';
import Login from './Login';

/**
 * Componente chamado depois que o usuário for autenticado
 *
 * @param {*} props
 * @returns
 */
const Authentication = (props) => {
  const auth = useAuth();
  if (auth && auth.userData) props.setAuthContext(auth);
  return <></>;
};

/**
 * Componente que realiza autenticação do usuário
 *
 * @param {*} props
 * @returns
 */
const Auth = () => {
  const userContext = useContext(UserContext);

  const [authContext, setAuthContext] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [authWith, setAuthWith] = useState(null);
  const [authFailureMessage, setAuthFailureMessage] = useState(null);

  /**
   * Callback de sucesso na autenticação
   */
  const successCallback = () => {
    setIsLoading(false);
  };

  const restartAuthetication = () => {
    setIsLoading(true);
    setAuthFailureMessage(null);
    localStorage.removeItem('provider');
    authContext.signOut();
  };

  const failureCallback = (errorData = null) => {
    if (errorData && errorData.messages.length > 0) {
      setAuthFailureMessage(errorData.messages.join(' '));
    } else {
      restartAuthetication();
    }
  };

  /**
   * Cria a função de signOut que pode ser usado no auth context
   *
   * O provider acessogovbr precisa remover o usuario do storage
   * authContext.userManager.removeUser();
   * e encaminhar para um endpoint fora do padrão open-id
   * @returns
   */
  const createSignOutCallback = (provider) => {
    let signOutCallback = authContext.signOutRedirect;
    const govbrConfig = PROVIDER_CONFIG.govbr;
    if (provider === govbrConfig.alias) {
      const endpoint = `${govbrConfig.authority}/logout?post_logout_redirect_uri=${govbrConfig.postLogoutRedirectUri}`;
      signOutCallback = () => {
        authContext.userManager.removeUser();
        window.location.href = endpoint;
      };
    }
    return signOutCallback;
  };

  /**
   *  Efeito exectutado quando o Auth é montado
   *  Preenche o estado AuthWith se existir algum provider armazenado
   *  no local storage com time to live valido
   */
  useEffect(() => {
    setAuthWith(getStorageWithTtl('provider'));
  }, []);

  /**
   *   Efeito exectutado quando o authContext é alterado
   *   Chama o signin do userContext passando o auth context
   *   gerado pelo provider (acessogovbr ou login unico)
   *
   *   armazena o provider com tempo de vida igual ao tempo de expiração da autenticação
   */
  useEffect(() => {
    if (authContext) {
      if (isLoading) return null;
      const auth = authContext;
      auth.signOut = createSignOutCallback(`${authWith}`);

      setAuthContext(auth);
      setIsLoading(true);
      setShowLogin(false);
      setAuthWith(null);

      sessionStorage.removeItem('provider');
      setStorageWithTtl('provider', authWith, authContext.userData.expires_in * 1000);
      userContext.signin(authContext, authWith, successCallback, failureCallback);
    }
  }, authContext);

  useEffect(() => {

  }, []);

  /* Hack para funcionar em desenvolvmento local  */
  if (window.location.hostname === 'localhost') {
    userContext.setUser(
      {
        name: 'Serprobots Mocked User',
        department: 'DIDES/SUPAI/AICEI/AIPLN',
        email: 'serprobots@serpro.gov.br',
        username: '11111111111',
      },
    );
    return <></>;
  }

  if (authWith) {
    /* adicionar provider no storage de sessão */
    setStorageWithTtl('provider', authWith, 300000, true);

    return (
      <>
        <Loading />
        <AuthProvider {...PROVIDER_CONFIG[authWith]}>
          <Authentication setAuthContext={setAuthContext} />
        </AuthProvider>
      </>
    );
  }

  if (authFailureMessage != null) {
    return (
      <DialogNotification
        okAction={restartAuthetication}
        title={<p style={{ whiteSpace: 'nowrap' }}>Não foi possível autenticar o usuário</p>}
        content={<p>{authFailureMessage}</p>}
      />
    );
  }

  if (showLogin) {
    return (
      <Login
        setShowLogin={setShowLogin}
        setProviderAuth={setAuthWith}
      />
    );
  }

  if (isLoading) return <Loading />;

  return <></>;
};

export default Auth;
